import { MainTimelineSteps } from "./indivExp/mainTimelineContent";

const MainTimelineContent = [
  {
    id: "main-timeline",
    title: "Large Scale QnA System with GenAI",
    desc: "Full Stack Solution  Development for Large Scale QnA System using Generative AI",
    img: "./assets/images/experiment_images/dark_theme_state.png",
    steps: MainTimelineSteps,
  },
];

export { MainTimelineContent };
